import { apiV1 } from './apiClient';

/**
 * API para gestión de empresas (V1)
 * Consume endpoints de backend/src/routes/v1/empresaRoutes.js
 */
const empresasApi = {
  /**
   * GET /api/v1/empresas
   * Listar todas las empresas con información completa
   */
  listar: async () => {
    const response = await apiV1.get('/empresas');
    return response.data;
  },

  /**
   * GET /api/v1/empresas/:id
   * Obtener una empresa por ID
   */
  obtener: async (id) => {
    const response = await apiV1.get(`/empresas/${id}`);
    return response.data;
  },

  /**
   * POST /api/v1/empresas
   * Crear una nueva empresa
   */
  crear: async (data) => {
    const response = await apiV1.post('/empresas', data);
    return response.data;
  },

  /**
   * PUT /api/v1/empresas/:id
   * Actualizar una empresa existente
   */
  actualizar: async (id, data) => {
    const response = await apiV1.put(`/empresas/${id}`, data);
    return response.data;
  },

  /**
   * DELETE /api/v1/empresas/:id
   * Eliminar (desactivar) una empresa
   */
  eliminar: async (id) => {
    const response = await apiV1.delete(`/empresas/${id}`);
    return response.data;
  },

  /**
   * POST /api/v1/empresas/aprobar/:id
   * Aprobar un negocio/empresa pendiente
   */
  aprobarNegocio: async (id) => {
    const response = await apiV1.post(`/empresas/aprobar/${id}`);
    return response.data;
  },

  /**
   * POST /api/v1/empresas/rechazar/:id
   * Rechazar una empresa pendiente
   */
  rechazarNegocio: async (id, motivo) => {
    const response = await apiV1.post(`/empresas/rechazar/${id}`, { motivo });
    return response.data;
  },

  /**
   * GET /api/v1/empresas/mi-empresa
   * Obtener información de la empresa del usuario autenticado
   */
  obtenerMiEmpresa: async () => {
    const response = await apiV1.get('/empresas/mi-empresa');
    return response.data;
  },

  /**
   * PUT /api/v1/empresas/mi-empresa
   * Actualizar información de la empresa del usuario autenticado
   */
  actualizarMiEmpresa: async (data) => {
    const response = await apiV1.put('/empresas/mi-empresa', data);
    return response.data;
  }
};

export default empresasApi;
